import styled from '@emotion/styled'
import { Switch as MaterialSwitch } from '@mui/material'
import { noop } from 'lodash'
import * as React from 'react'

export type SwitchProps = {
  'data-testid'?: string
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: (r: boolean) => void
  size?: 'small' | 'medium'
}

const StyledSwitch = styled(MaterialSwitch)`
  .MuiSwitch-track {
    background-color: var(--White90);
    opacity: 1;
  }
  .MuiSwitch-colorSecondary.Mui-checked {
    color: var(--Orange-Dark);
  }

  .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track {
    background-color: var(--White90);
    opacity: 1;
  }

  .Mui-disabled {
    display: none;
  }

  .MuiSwitch-colorSecondary.Mui-disabled + .MuiSwitch-track {
    background-color: var(--White95);
    opacity: 1;
  }
`

export const Switch = ({
  isChecked,
  isDisabled,
  onChange = noop,
  size = 'medium',
  ...props
}: SwitchProps) => {
  const inputProps = { 'aria-label': 'secondary checkbox', 'data-testid': props['data-testid'] }

  return (
    <StyledSwitch
      checked={isChecked}
      disabled={isDisabled}
      inputProps={inputProps}
      size={size}
      onChange={e => onChange(e.target.checked)}
    />
  )
}
